import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReferencesComponent } from './references.component';
import { BtnModule } from 'libraries/ui_button/btn.module';
import { RouterModule } from '@angular/router';
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { PermissionModule } from "libraries/permission/permission.module";

@NgModule({
    declarations: [
        ReferencesComponent,
    ],
    imports: [
        BtnModule,
        CommonModule,
        HostAliasPipeModule,
        PermissionModule,
        RouterModule,
    ],
    exports: [
        ReferencesComponent,
    ],
    providers: [],
})
export class ReferencesModule {}
